import { AxiosPromise} from 'axios';

export interface ICmsBlocks {
  items: ICMSBlockItem[]
  __typename: string
}

export interface ICMSBlockItem {
  content: string
  identifier: string
  __typename: string
}

export interface IDataCMSBlock {
  cmsBlocks: ICmsBlocks
}

export interface ICMSBlockResponse {
  data: IDataCMSBlock
}


export interface IProductDetail {
  id: string;
  alias: string;
  image: string;
  name: string;
  brand: string;
  url: string;
  price: number;
  price_discounted: number;
  payload: IPayloadProduct;
}


interface IPayloadProduct {
  metadata: {
    price: Price;
    type_id: string;
    product_id: string;
    promotext_code?: string
    promotext_type?: string
    promotext_value?: string
  };
  has_coupon: string;
  is_preowned: string;
  in_stock: string;
}

interface Price {
  USD: USD;
}

interface USD {
  default: number;
  now_price: number;
  was_price: number;
  default_formatted: string;
  discount_formatted: string;
  now_price_formatted: string;
  was_price_formatted: string;
}

interface IProductSuggestion {
  skip?: number
  limit?: number
  has_more?: boolean
  approximate_hits?: number
  data: IProductDetail[]
  autocomplete_suggestions: Record<string, string>[]
}

export interface IDataProductDetail {
  suggestions: IProductSuggestion
}

export interface IProductDetailResponse {
  data: IDataProductDetail
}

export const getFilterProduct = (queryKey?: string): AxiosPromise<IProductDetailResponse> | Promise<null> => {
  // Disable Miros as it is not responding
  // - (This can be converted to another provider in a later ticket)
  return Promise.resolve(null);

  // Previous code - For reference to convert
  // const payload = {
  //   operationName: "Suggestions",
  //   variables: {
  //     integration_id: _get(process.env, 'REACT_APP_JOMASHOP_MIROS_INTEGRATION_KEY', ''),
  //     skipAutocomplete: false,
  //     skipFilterFacets: true,
  //     limit: 20,
  //     skip: 0,
  //     text_query: queryKey,
  //     text_query_lang: "en",
  //     payload_paths: [
  //       "metadata",
  //       "has_coupon",
  //       "is_tester",
  //       "is_labgrown",
  //       "is_preowned",
  //       "in_stock"
  //     ],
  //     facetList: []
  //   },
  //   query: `query Suggestions($integration_id: String!, $text_query: String!, $text_query_lang: String, $filter_query: JSONObject, $limit: Int!, $skip: Int!, $skipAutocomplete: Boolean! = false, $skipFilterFacets: Boolean! = false, $payload_paths: [String!], $sort: SortOption, $mode: SearchOption, $facetList: [String!]) {
  //     suggestions(query: {integration_id: $integration_id, text_query: $text_query, text_query_language: $text_query_lang, filter_query: $filter_query, limit: $limit, skip: $skip, payload_paths: $payload_paths, sort: $sort, mode: $mode, facet_list: $facetList}) {
  //       filter_facets @skip(if: $skipFilterFacets)
  //       has_more
  //       autocomplete_suggestions @skip(if: $skipAutocomplete) {suggestion}
  //       approximate_hits
  //       skip
  //       limit
  //       data {
  //         id
  //         alias
  //         image
  //         name
  //         brand
  //         url
  //         price
  //         price_discounted
  //         payload
  //       }
  //     }
  //   }`
  // };
  //
  // return axios.post(
  //   `${_get(process.env, 'REACT_APP_JOMASHOP_GLOBAL_MICROS_API', 'https://global.api.miros.services')}/graphql`,
  //   payload,
  //   {
  //     headers: {
  //       'Content-Type': 'application/json',
  //       "x-miros-key": _get(process.env, 'REACT_APP_JOMASHOP_MIROS_KEY', ''),
  //       "x-miros-integration": _get(process.env, 'REACT_APP_JOMASHOP_MIROS_INTEGRATION_KEY', '')
  //     }
  //   }
  // );
};